import { draggable } from "@/common/draggable"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".examples-row.sortables") as HTMLElement | undefined

  if (container) {
    draggable(container, container.dataset.updateUrl)
  }
})
